import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import TabNavigation from './TabNavigation';
import MobileTabBar from './MobileTabBar';

const AppLayout: React.FC = () => {
    const location = useLocation();
    const isHomePage = location.pathname === '/';

    return (
        <div className="min-h-screen bg-gray-50">
            {/* Desktop Top Navigation - always centered */}
            <header className="hidden md:flex fixed top-0 left-0 right-0 z-40 py-4 justify-center">
                <TabNavigation />
            </header>

            {/* Main Content */}
            <main className={`${!isHomePage ? 'md:pt-20 pb-20 md:pb-0' : ''}`}>
                <Outlet />
            </main>

            {/* Mobile Bottom Tab Bar */}
            <MobileTabBar />
        </div>
    );
};

export default AppLayout;

